import { render, staticRenderFns } from "./PlayerHeader.vue?vue&type=template&id=2a31bdd0&scoped=true&"
import script from "./PlayerHeader.vue?vue&type=script&lang=js&"
export * from "./PlayerHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlayerHeader.vue?vue&type=style&index=0&id=2a31bdd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31bdd0",
  null
  
)

export default component.exports